import { ThemeVariables } from 'styles/theme';

export default function ({ }: ThemeVariables) {
  return {
    // logo: require('./assets/images/health.png'),
  };
}

